import { useMutation, useQuery } from 'react-query';
import { request, request_v2 } from '../utils/axios-utils';

const getUserAclListing = async (pageNum, pageSize, name, clientCode, component) => {
    const params = new URLSearchParams({
        pageNum,
        pageSize,
        searchName: name || '',
    });
    if (clientCode) {
        params.set('clientCode', clientCode);
    }
    if (component) {
        params.set('component', component);
    }
    const { data } = await request({
        method: 'get',
        url: `/user/listUsersForACL?${params.toString()}`,
    });
    return data;
};

export const useUsersAclComponentListing = (pageNum, pageSize, name, clientCode, component) =>
    useQuery(
        ['usersAclComponents', pageNum, pageSize, name, clientCode, component],
        () => getUserAclListing(pageNum, pageSize, name, clientCode, component),
        {
            refetchOnWindowFocus: false,
        }
    );

const updateAclData = data => {
    return request({
        url: '/user/updateACLData',
        method: 'patch',
        data,
    });
};

export const useUpdateClientAcl = onSuccess => {
    return useMutation(updateAclData, {
        onSuccess: onSuccess,
    });
};

const getUserDesignationListing = async (pageNum, pageSize) => {
    const { data } = await request_v2({
        method: 'get',
        url: '/user/listComponents',
    });
    return data;
};

export const useUsersDesignationListing = () =>
    useQuery(['usersAclComponents'], () => getUserDesignationListing(), {
        refetchOnWindowFocus: false,
    });

